/* ==========================================================================
   Koolseed — Sepet
   Cart AJAX API + Section Rendering API. Sepet değişince yalnızca ilgili
   bölümler yeniden çizilir, sayfa yenilenmez.
   ========================================================================== */

(function () {
  'use strict';

  const ROUTES = window.KS_ROUTES || {};
  const cartAdd = ROUTES.cart_add || '/cart/add';
  const cartChange = ROUTES.cart_change || '/cart/change';
  const cartUrl = ROUTES.cart || '/cart';

  /** Sepet değiştiğinde yeniden çizilecek bölümler. */
  function sectionsToRender() {
    const ids = [];
    if (document.getElementById('ks-cart-drawer')) ids.push('ks-cart-drawer');
    const main = document.querySelector('[data-ks-cart-section]');
    if (main) ids.push(main.dataset.ksCartSection);
    // "Birlikte Al, Kazan": fiyatlar ve vaat sepete göre değişiyor. Hesap
    // sunucuda (ks-pdp-bundle.liquid); liste her değişiklikte oradan geliyor.
    const bundle = document.querySelector('[data-bundle-section]');
    if (bundle && !ids.includes(bundle.dataset.bundleSection)) ids.push(bundle.dataset.bundleSection);
    return ids;
  }

  async function postCart(url, body) {
    const sections = sectionsToRender();
    const payload = Object.assign({}, body, {
      sections: sections.join(','),
      sections_url: window.location.pathname
    });

    const response = await fetch(`${url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });

    const data = await response.json();
    if (!response.ok) {
      const message = data.description || data.message || 'Sepet güncellenemedi.';
      throw new Error(message);
    }
    return data;
  }

  /** Sunucudan gelen section HTML'lerini yerine koyar. */
  function applySections(data) {
    if (!data.sections) return;

    Object.keys(data.sections).forEach((id) => {
      const html = data.sections[id];
      if (!html) return;

      const bundle = document.querySelector('[data-bundle-section]');
      if (bundle && id === bundle.dataset.bundleSection) {
        // Ürün bölümünün tamamı değil yalnızca liste değişiyor: galeri,
        // seçili varyant ve açık akordiyonlar yerinde kalsın.
        const freshBundle = window.KS.extract(html, '[data-bundle-section]');
        if (freshBundle) {
          bundle.className = freshBundle.className;
          bundle.innerHTML = freshBundle.innerHTML;
        }
        return;
      }

      if (id === 'ks-cart-drawer') {
        // Gövde ve alt bilgi ayrı ayrı: alt bilgideki "Alışverişi Tamamla"
        // sepet boşken pasif oluyor, o yüzden o da tazelenmeli.
        ['[data-cart-body]', '.ks-drawer__foot'].forEach((selector) => {
          const fresh = window.KS.extract(html, selector);
          const current = document.querySelector(`#ks-cart-drawer ${selector}`);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
      } else {
        const fresh = window.KS.extract(html, '[data-ks-cart-section]');
        const current = document.querySelector('[data-ks-cart-section]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      }
    });

    updateCount(data.item_count);

    // Sepetin tamamı döndüyse (change/update) sayfadaki satır kontrolleri de
    // güncel kalsın — drawer'dan silinen bir ürün "Birlikte Al"da hâlâ adet
    // göstermesin.
    if (Array.isArray(data.items)) syncBundleControls(data.items);
  }

  function syncBundleControls(lines) {
    document.querySelectorAll('ks-bundle-add').forEach((control) => {
      if (typeof control.setQuantity !== 'function') return;
      const variantId = Number(control.dataset.variant);
      const line = lines.find((item) => item.variant_id === variantId);
      control.setQuantity(line ? line.quantity : 0);
    });
  }

  function updateCount(count) {
    if (typeof count !== 'number') return;

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      if (el.hasAttribute('hidden') || el.classList.contains('ks-header__cart-count')) {
        el.hidden = count === 0;
      }
    });

    const label = document.querySelector('[data-cart-count-label]');
    if (label && window.KS_STRINGS && window.KS_STRINGS.cartCount) {
      label.textContent = window.KS_STRINGS.cartCount.replace('{{ count }}', count);
    }
  }

  /* ---- Sepete ekleme formu ---------------------------------------------- */

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.button = this.form.querySelector('[type="submit"]');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.button && this.button.getAttribute('aria-disabled') === 'true') return;

      this.setLoading(true);
      const formData = new FormData(this.form);
      const body = {};
      formData.forEach((value, key) => {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan') body[key] = value;
        else if (key.startsWith('properties[')) {
          body.properties = body.properties || {};
          body.properties[key.slice(11, -1)] = value;
        }
      });

      try {
        const data = await postCart(cartAdd, { items: [body] });
        applySections(data);

        this.setLoading(false);
        this.flashAdded();
        bumpCartIcon();
        document.dispatchEvent(new CustomEvent('ks:cart:open'));
      } catch (error) {
        this.setLoading(false);
        window.KS.toast(error.message, 'error');
      }
    }

    setLoading(loading) {
      if (!this.button) return;
      this.button.setAttribute('aria-disabled', String(loading));
      this.button.classList.toggle('is-loading', loading);
    }

    /* Butonun kendisi "Sepete Eklendi ✓" gösterir; toast yerine buton
       üzerinde geri bildirim vermek tıklanan yeri işaret ediyor. */
    flashAdded() {
      const button = this.button;
      if (!button) return;

      const strings = window.KS_STRINGS || {};
      const label = button.dataset.addedLabel || strings.added || 'Sepete Eklendi';
      button.dataset.addedLabel = label;
      button.classList.add('is-added');
      button.setAttribute('aria-disabled', 'true');

      window.clearTimeout(this.addedTimer);
      this.addedTimer = window.setTimeout(() => {
        button.classList.remove('is-added');
        button.setAttribute('aria-disabled', 'false');
      }, 1600);
    }
  }

  /** Header'daki sepet ikonuna kısa bir zıplama. */
  function bumpCartIcon() {
    const icon = document.querySelector('.ks-header__cart');
    if (!icon) return;
    icon.classList.remove('is-bumped');
    // Sınıfı hemen geri eklersek animasyon yeniden başlamaz; reflow gerekiyor.
    void icon.offsetWidth;
    icon.classList.add('is-bumped');
    window.setTimeout(() => icon.classList.remove('is-bumped'), 600);
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  /* ---- Drawer içi adet/silme -------------------------------------------- */

  class KsCartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
    }

    onChange(event) {
      const input = event.target.closest('input[name="updates[]"]');
      if (!input) return;
      this.updateLine(input.dataset.index, input.value);
    }

    onClick(event) {
      const remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;
      event.preventDefault();
      this.updateLine(remove.dataset.index, 0);
    }

    async updateLine(line, quantity) {
      const body = document.querySelector('#ks-cart-drawer [data-cart-body]');
      if (body) body.classList.add('is-busy');

      try {
        const data = await postCart(cartChange, { line: Number(line), quantity: Number(quantity) });
        applySections(data);
      } catch (error) {
        window.KS.toast(error.message, 'error');
      } finally {
        const fresh = document.querySelector('#ks-cart-drawer [data-cart-body]');
        if (fresh) fresh.classList.remove('is-busy');
      }
    }
  }
  if (!customElements.get('ks-cart-drawer')) customElements.define('ks-cart-drawer', KsCartDrawer);

  /* ---- Sepet sayfası ----------------------------------------------------- */

  const page = document.querySelector('[data-ks-cart-section]');
  if (page) {
    page.addEventListener('change', async (event) => {
      const input = event.target.closest('input[name="updates[]"]');
      if (!input) return;
      try {
        applySections(await postCart(cartChange, { line: Number(input.dataset.index), quantity: Number(input.value) }));
      } catch (error) {
        window.KS.toast(error.message, 'error');
      }
    });

    page.addEventListener('click', async (event) => {
      const remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;
      event.preventDefault();
      try {
        applySections(await postCart(cartChange, { line: Number(remove.dataset.index), quantity: 0 }));
      } catch (error) {
        window.KS.toast(error.message, 'error');
      }
    });
  }

  /* ---- "Birlikte Al, Kazan" satır kontrolü --------------------------------
     Satır sepette değilken tek bir "+" görünür. Eklendiği anda solunda "−"
     ve adet beliriyor; artırma/azaltma drawer'ı açmadan yerinde oluyor.
     Sıfıra inince satır sepetten çıkıyor ve kontrol başa dönüyor. */

  class KsBundleAdd extends HTMLElement {
    connectedCallback() {
      this.variantId = Number(this.dataset.variant);
      this.countEl = this.querySelector('[data-bundle-count]');
      this.minusBtn = this.querySelector('[data-bundle-minus]');
      this.addBtn = this.querySelector('[data-bundle-plus]');
      this.addEventListener('click', this.onClick.bind(this));
    }

    get quantity() {
      return Number(this.dataset.qty) || 0;
    }

    onClick(event) {
      const button = event.target.closest('button');
      if (!button || this.busy) return;
      event.preventDefault();

      const delta = button.hasAttribute('data-bundle-minus') ? -1 : 1;
      const next = this.quantity + delta;
      if (next < 0) return;
      this.apply(next);
    }

    async apply(next) {
      this.busy = true;
      this.classList.add('is-busy');
      const previous = this.quantity;

      try {
        let quantity;
        if (previous === 0) {
          // İlk ekleme: /cart/add.js satırın sepetteki toplam adedini döndürür.
          const data = await postCart(cartAdd, { items: [{ id: this.variantId, quantity: 1 }] });
          applySections(data);
          quantity = this.readAddedQuantity(data, 1);
          bumpCartIcon();
        } else {
          // Var olan satır: /cart/change.js id olarak varyant kimliğini kabul eder.
          const data = await postCart(cartChange, { id: String(this.variantId), quantity: next });
          applySections(data);
          quantity = this.readCartQuantity(data, next);
        }
        this.setQuantity(quantity);
      } catch (error) {
        window.KS.toast(error.message, 'error');
      } finally {
        this.busy = false;
        this.classList.remove('is-busy');
      }
    }

    readAddedQuantity(data, fallback) {
      if (typeof data.quantity === 'number') return data.quantity;
      if (Array.isArray(data.items)) {
        const line = data.items.find((item) => item.variant_id === this.variantId);
        if (line) return line.quantity;
      }
      return fallback;
    }

    readCartQuantity(cart, fallback) {
      if (!cart || !Array.isArray(cart.items)) return fallback;
      const line = cart.items.find((item) => item.variant_id === this.variantId);
      return line ? line.quantity : 0;
    }

    setQuantity(quantity) {
      this.dataset.qty = String(quantity);
      if (this.countEl) this.countEl.textContent = quantity;
      this.classList.toggle('is-active', quantity > 0);
      if (this.minusBtn) this.minusBtn.tabIndex = quantity > 0 ? 0 : -1;
    }
  }
  if (!customElements.get('ks-bundle-add')) customElements.define('ks-bundle-add', KsBundleAdd);

  /* ---- Tekrar sipariş ver ------------------------------------------------
     Bağlantı normalde cart permalink'ine gider (JS yoksa da çalışsın diye).
     JS varsa isteği araya alıp sepete ekliyoruz; sayfa değişmiyor. */

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-ks-reorder-add]');
    if (!trigger) return;

    let items;
    try {
      items = JSON.parse(trigger.dataset.ksReorderAdd);
    } catch (error) {
      return; // Bozuk yük: bağlantı normal gezinmeye düşsün.
    }
    if (!Array.isArray(items) || !items.length) return;

    event.preventDefault();
    trigger.classList.add('is-loading');

    try {
      applySections(await postCart(cartAdd, { items }));
      trigger.classList.remove('is-loading');
      bumpCartIcon();
      closeReorderPopover();
      document.dispatchEvent(new CustomEvent('ks:cart:open'));
    } catch (error) {
      trigger.classList.remove('is-loading');
      window.KS.toast(error.message, 'error');
    }
  });

  const REORDER_SEEN = 'ks-reorder-seen';

  function closeReorderPopover() {
    const popover = document.querySelector('[data-ks-reorder-popover]');
    if (!popover || popover.hidden) return;
    popover.classList.remove('is-open');
    popover.hidden = true;
    try {
      window.sessionStorage.setItem(REORDER_SEEN, '1');
    } catch (error) {
      /* Gizli sekmede sessionStorage kapalı olabilir; sorun değil. */
    }
  }

  function initReorderPopover() {
    const popover = document.querySelector('[data-ks-reorder-popover]');
    if (!popover) return;

    let seen = false;
    try {
      seen = window.sessionStorage.getItem(REORDER_SEEN) === '1';
    } catch (error) {
      seen = false;
    }
    if (seen) return;

    // Sayfa oturmadan açılmasın; tasarımda header yerleştikten sonra beliriyor.
    window.setTimeout(() => {
      popover.hidden = false;
      window.requestAnimationFrame(() => popover.classList.add('is-open'));
    }, 1200);

    popover.addEventListener('click', (event) => {
      if (event.target.closest('[data-ks-reorder-close]')) closeReorderPopover();
    });

    // Sepet ya da menü açılırsa popover yoldan çekilsin.
    document.addEventListener('ks:cart:open', closeReorderPopover);
    document.addEventListener('click', (event) => {
      if (popover.hidden) return;
      if (event.target.closest('[data-ks-reorder-popover]')) return;
      if (event.target.closest('.ks-header__btn')) closeReorderPopover();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReorderPopover);
  } else {
    initReorderPopover();
  }

  window.KS.cart = { postCart, applySections, updateCount, bumpCartIcon, cartUrl };
})();
